import { Component } from '@angular/core';

@Component({
    selector: 'app-purchase-index',
    templateUrl: './index.component.html',
    styleUrls: ['./purchase.component.scss']
})
export class IndexComponent { }
